import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "@emotion/styled/base";
var _excluded = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
var EmotionIconBaseBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      iconAttrs = props.iconAttrs,
      iconVerticalAlign = props.iconVerticalAlign,
      iconViewBox = props.iconViewBox,
      size = props.size,
      title = props.title,
      otherProps = _objectWithoutProperties(props, _excluded);

  var iconProps = _objectSpread(_objectSpread({
    viewBox: iconViewBox,
    height: props.height !== undefined ? props.height : size,
    width: props.width !== undefined ? props.width : size,
    'aria-hidden': title == null ? 'true' : undefined,
    focusable: 'false',
    role: title != null ? 'img' : undefined
  }, iconAttrs), otherProps);

  return /*#__PURE__*/React.createElement("svg", _extends({}, iconProps, {
    ref: ref
  }), title && /*#__PURE__*/React.createElement("title", {
    key: "icon-title"
  }, title), children);
});
export var EmotionIconBase = /*#__PURE__*/_styled(EmotionIconBaseBase, process.env.NODE_ENV === "production" ? {
  target: "ex0cdmw0"
} : {
  target: "ex0cdmw0",
  label: "EmotionIconBase"
})("display:inline-block;vertical-align:", function (props) {
  return props.iconVerticalAlign;
}, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QzBEIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgdmFsaWRQcm9wIGZyb20gJ0BlbW90aW9uL2lzLXByb3AtdmFsaWQnXG5cbmV4cG9ydCB0eXBlIEVtb3Rpb25JY29uID0gUmVhY3QuRm9yd2FyZFJlZkV4b3RpY0NvbXBvbmVudDxcbiAgUmVhY3QuUHJvcHNXaXRob3V0UmVmPEVtb3Rpb25JY29uUHJvcHM+ICYgUmVhY3QuUmVmQXR0cmlidXRlczxTVkdTVkdFbGVtZW50PlxuPlxuXG5leHBvcnQgaW50ZXJmYWNlIEVtb3Rpb25JY29uUHJvcHMgZXh0ZW5kcyBSZWFjdC5Qcm9wc1dpdGhSZWY8UmVhY3QuU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+IHtcbiAgc2l6ZT86IG51bWJlciB8IHN0cmluZ1xuICB0aXRsZT86IHN0cmluZyB8IG51bGxcbn1cblxuaW50ZXJmYWNlIEVtb3Rpb25JY29uQmFzZVByb3BzIHtcbiAgaWNvbkF0dHJzOiBSZWFjdC5TVkdQcm9wczxTVkdTVkdFbGVtZW50PlxuICBpY29uVmlld0JveDogc3RyaW5nXG4gIGljb25WZXJ0aWNhbEFsaWduOiBzdHJpbmdcbn1cblxuY29uc3QgRW1vdGlvbkljb25CYXNlQmFzZSA9IFJlYWN0LmZvcndhcmRSZWY8U1ZHU1ZHRWxlbWVudCwgRW1vdGlvbkljb25Qcm9wcyAmIEVtb3Rpb25JY29uQmFzZVByb3BzPigocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7Y2hpbGRyZW4sIGljb25BdHRycywgaWNvblZlcnRpY2FsQWxpZ24sIGljb25WaWV3Qm94LCBzaXplLCB0aXRsZSwgLi4ub3RoZXJQcm9wc30gPSBwcm9wc1xuXG4gIGNvbnN0IGljb25Qcm9wczogUmVhY3QuU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4gPSB7XG4gICAgdmlld0JveDogaWNvblZpZXdCb3gsXG4gICAgaGVpZ2h0OiBwcm9wcy5oZWlnaHQgIT09IHVuZGVmaW5lZCA/IHByb3BzLmhlaWdodCA6IHNpemUsXG4gICAgd2lkdGg6IHByb3BzLndpZHRoICE9PSB1bmRlZmluZWQgPyBwcm9wcy53aWR0aCA6IHNpemUsXG4gICAgJ2FyaWEtaGlkZGVuJzogdGl0bGUgPT0gbnVsbCA/ICd0cnVlJyA6IHVuZGVmaW5lZCxcbiAgICBmb2N1c2FibGU6ICdmYWxzZScsXG4gICAgcm9sZTogdGl0bGUgIT0gbnVsbCA/ICdpbWcnIDogdW5kZWZpbmVkLFxuICAgIC4uLmljb25BdHRycyxcbiAgICAuLi5vdGhlclByb3BzLFxuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8c3ZnIHsuLi5pY29uUHJvcHN9IHJlZj17cmVmfT5cbiAgICAgIHt0aXRsZSAmJiA8dGl0bGUga2V5PVwiaWNvbi10aXRsZVwiPnt0aXRsZX08L3RpdGxlPn1cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L3N2Zz5cbiAgKVxufSlcblxuZXhwb3J0IGNvbnN0IEVtb3Rpb25JY29uQmFzZSA9IHN0eWxlZChFbW90aW9uSWNvbkJhc2VCYXNlKWBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB2ZXJ0aWNhbC1hbGlnbjogJHsocHJvcHMpID0+IHByb3BzLmljb25WZXJ0aWNhbEFsaWdufTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmBcbiJdfQ== */"));